import { TelemetryManager } from "@faire/web--source/common/opentelemetry/TelemetryManager";
import { ActionName } from "@faire/web--source/common/performance/userPerceivedLoadTiming/types";
import { useRef } from "react";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { usePrefetchSearchPage } from "@faire/retailer/views/search-v2/__internal__/LazySearchPage/__internal__/usePrefetchSearchPage";
import { useSearchPageActionName } from "@faire/retailer/views/search-v2/util/useSearchPageActionName";

//Use the logic of useMaybePrefetchSearchPage to prefetch the discover page
export const useMaybePrefetchDiscoverPage = () => {
  const name: ActionName = useSearchPageActionName();
  TelemetryManager.get().startTrace(`uplt-${name}`);

  const prefetchSearchPage = usePrefetchSearchPage();
  const previousPrefetchSearchPageRef = useRef<(() => void) | undefined>(
    undefined
  );

  //Only prefetch on non-SSR
  if (prefetchSearchPage !== previousPrefetchSearchPageRef.current) {
    // Prefetch when the URL changes
    prefetchSearchPage();
    previousPrefetchSearchPageRef.current = prefetchSearchPage;
  }
};
